import * as React from "react";
import { useState } from "react";
import * as styles from "../ContactForm.module.scss";
import ContactCalendar from "../Calendar";

const CalendarForm = () => {
  // const [oneState, setOnestate] = useState("");
  const [user, setUser] = useState({
    userName: "",
    telephone: "",
    _replyto: "",
    company: "",
    content: ""
  });

  const [callDateTime, setCallDateTime] = useState("Today 10:00");

  const { userName, telephone, _replyto, company, content } = user;

  const handleInputChange = e => {
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value
    });
  };

  const handleCallDateTime = (callDate, callTime) => {
    setCallDateTime(`${callDate?.toLocaleDateString()} ${callTime}:00`)
  }

  return (
    <div className={styles.calendar_container}>
      <ContactCalendar handleCallDateTime={handleCallDateTime} />
      <form
        className={styles.calendar_form_grid}
        method="post"
        action="https://formspree.io/f/meqvjyej"
      >
        <input
          value={userName}
          onChange={handleInputChange}
          type="text"
          name="userName"
          placeholder="Full name*"
          required
        />
        <input
          value={telephone}
          onChange={handleInputChange}
          type="text"
          name="telephone"
          placeholder="Telephone*"
          required
        />
        <input
          value={_replyto}
          onChange={handleInputChange}
          type="email"
          name="_replyto"
          placeholder="Email*"
        />
        <input
          value={company}
          onChange={handleInputChange}
          type="text"
          name="company"
          placeholder="Company*"
          required
        />
        <textarea
          value={content}
          onChange={handleInputChange}
          type="text"
          placeholder="Tell us about your project"
          name="content"
        />
        <input
          type="submit"
          value="Send Now"
        ></input>
        <input type="hidden" name="Call date/time" value={callDateTime}></input>
      </form>
    </div>
  );
};

export default CalendarForm;
